import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { ModalViewComponent } from '../modal-view.shared.component';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-modal-for-history-order',
    templateUrl: './modal-for-history-order.shared.component.html',
    styleUrls: ['./modal-for-history-order.shared.component.scss']
})
export class ModalForHistoryOrderComponent extends ModalViewComponent implements OnInit, OnDestroy {
    @Input() public preTitle: string = 'ORDER DETAILS';

    public title$: Observable<string>;
    public locationName$: Observable<string>;
    public orderIsActive$: Observable<boolean>;
    public orderItems$: Observable<OLO.Ordering.IOnlineOrderMappedProducts>;
    public isSendingEmailReceipt$: Observable<boolean>;
    public isFinalized$: Observable<boolean>;

    public isEmailSending$: Observable<boolean>;
    public hasEmailSendingSucceeded$: Observable<boolean>;
    public hasEmailSendingFailed$: Observable<boolean>;

    constructor(
        public modalsService: Services.ModalsService,
        public heightAdjustService: Services.HeightAdjustService,
        public controllers: Controllers,
    ) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.dimmedBg = true;
        this.fullPaddings = true;
        this.shadow = true;

        this.title$ = this.controllers.historyOrders.getHistoryOrderTitle$(this.modalData.orderId);
        this.locationName$ = this.controllers.locations.locationFriendlyName$(this.modalData.locationNo);
        this.orderIsActive$ = this.controllers.historyOrders.isOrderActive$(this.modalData.orderId);
        this.orderItems$ = this.controllers.historyOrders.mappedOrderItems$(this.modalData.orderId);
        this.isSendingEmailReceipt$ = this.controllers.onlineOrders.isSendingEmailReceipt$();
        this.isFinalized$ = this.controllers.historyOrders.isOrderFinalized$(this.modalData.orderId);

        this.hasEmailSendingSucceeded$ = this.controllers.onlineOrders.hasSendingEmailReceiptSucceeded$();
        this.hasEmailSendingFailed$ = this.controllers.onlineOrders.hasSendingEmailReceiptFailed$();
    }

    ngOnDestroy(): void {
        this.controllers.onlineOrders.resetSendingEmailReceiptState();
    }

    public handleScrollY($event: HTMLElement): void {

    }

    public handleEmailMyReceiptClick($event: Event): void {
        this.controllers.onlineOrders.sendEmailReceipt(this.modalData.orderId);
    }
}
